const ManageTemplate = () => {};
export default ManageTemplate;
